<template>
    <div>
        <div class="main_wrapper ion-padding">
            <ion-toolbar>
                <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length && routeName == 'auth_bank'">
                    <ion-button class="button_back" @click="goBack">
                        <ion-icon name="arrow-back-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-buttons slot="end">
                    <ion-button v-if="routeName == 'auth_bank'" class="pill next-pill-button" @click="skip('userForm')">
                        <span>Skip</span>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
            <div class="main_wrapper ion-padding">
                <div class="container">
                    <div class="auth-header">
                        <div class="auth-heading">
                            <h1>Bank Details</h1>
                            <p class="auth-subtext">Please enter details!</p>
                        </div>
                        <div class="brand-icon">
                            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                        </div>
                    </div>
                    <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                        :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
                        @submit.prevent="goNext('userForm')" @keyup.enter="goNext('userForm')">
                        <el-form-item prop="bankName" :required="true">
                            <el-select style="width: 100%" filterable v-model="formsData.userForm.bankName.value"
                                placeholder="Select Bank Name">
                                <div class="auth-header">
                                    <div class="auth-heading">
                                        <h1>Select Bank</h1>
                                    </div>
                                </div>

                                <el-option v-for="item in banks" :key="item.id" :label="item.bankName"
                                    :value="item.bankName" />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="bankAccountName" :required="true">
                            <el-input v-model="formsData.userForm.bankAccountName.value"
                                :placeholder="'Account Name'"></el-input>
                        </el-form-item>
                        <el-form-item prop="bsb" class="no-scroll">

                            <div class="el-input">
                                <input type="tel" class="el-input__inner" :value="formsData.userForm.bsb.value"
                                    placeholder="BSB" v-imask="formsData.userForm.bsb.mask"
                                    @accept="onFormMaskAccept($event, 'userForm', 'bsb')"
                                    @blur="checkFormValidation('userForm', true, 'bsb')" />

                            </div>
                        </el-form-item>
                        <el-form-item class="no-scroll" prop="bankAccountNumber" :required="true">
                            <div class="el-input">
                                <input type="tel" class="el-input__inner"
                                    :value="formsData.userForm.bankAccountNumber.value"
                                    placeholder="Bank Account Number"
                                    v-imask="formsData.userForm.bankAccountNumber.mask"
                                    @accept="onFormMaskAccept($event, 'userForm', 'bankAccountNumber')"
                                    @blur="checkFormValidation('userForm', true, 'bankAccountNumber')" />
                            </div>
                        </el-form-item>
                        <el-form-item class="button_submit mb0">
                            <el-button class="submit" type="blue" @click="goNext('userForm')"
                                :disabled="!formsData.userForm.isFormValid">
                                Continue
                            </el-button>
                        </el-form-item>
                    </el-form>

                    <div class="bg-overlay"></div>
                </div>
            </div>

            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>
        </div>
    </div>
</template>

<script>
import './Bank.scss';
import { onMounted, ref, inject } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";
import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";
import { ElMessageBox } from "@/components/Vendor/Element";

import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    directives: {
        imask: IMaskDirective,
    },
    components: {
        SvgIcon
    },
    setup() {
        const $store = useStore();
        const $route = useRoute();
        const $router = useRouter();

        const userData = $store.getters.GET_USER_DATA;
        const billing = userData.billing;
        const banks = ref([]);
        const routeName = $route.name;

        const setPageClassGlobal = inject("setPageClassGlobal");

        const formsDataArray = {
            userForm: {
                isFormValid: true,
                bankName: {
                    value: userData.bankNameBilling ? userData.bankNameBilling : null,
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "bankName",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                bankAccountName: {
                    value: billing.bankAccountName || "",
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "bankAccountName",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                bsb: {
                    value: billing.bankBsb
                        ? IMask.createMask(formMasks.bsb).resolve(billing.bankBsb)
                        : "",
                    mask: formMasks.bsb,
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "bsb",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                bankAccountNumber: {
                    value: billing.bankAccountNumber
                        ? IMask.createMask(formMasks.bankAccountNumber).resolve(
                            billing.bankAccountNumber
                        )
                        : "",
                    mask: formMasks.bankAccountNumber,
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "bankAccountNumber",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };

        async function getBanks() {
            const allBanks = await $store.dispatch("GET_ALL_BANK");
            banks.value = allBanks.data;
        }
        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            setFormRefs();
            // formsRefs.userForm.value.$el[0].focus();
            if (routeName == "profile_business") {
                checkFormValidation("userForm", true);
            } else {
                checkFormValidation("userForm", false);
            }
            setFormRefs();
            getBanks();
            // formsRefs.userForm.value.$el[0].focus();
        });

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    if (userData.role === 'locum' && userData.billing.type === 2) {
                        $router.push({
                            name: "auth_super",
                        });
                    } else {
                        $router.push({
                            name: "auth_gst",
                        });
                    }
                } catch (error) {
                    console.log(error);
                }
            })();
        };

        const {
            ["onFormMaskAccept"]: onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            copyFormResetValue,
            checkFormChanged,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            if (routeName == "profile_payout") {
                                checkFormChanged("userForm", true);
                                await $store.dispatch(
                                    "SAVE_USER_DATA",
                                    getFormValues(formName)
                                );
                                copyFormResetValue("userForm", true);
                                $router.push({
                                    name: "profile",
                                });
                            } else {
                                console.log(getFormValues(formName));
                                await $store.dispatch(
                                    "SAVE_USER_DATA",
                                    getFormValues(formName)
                                );
                                if (userData.role === 'locum' && userData.billing.type === 2) {
                                    $router.push({
                                        name: "auth_super",
                                    });
                                } else {
                                    $router.push({
                                        name: "auth_gst",
                                    });
                                }
                            }
                        } catch (error) {
                            console.log("error submit!!");
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };
        const goBack = async() => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });
        };

        return {
            formsData,
            onFormMaskAccept,
            checkFormValidation,
            goNext,
            banks,
            routeName,
            skip,
            goBack
        };
    },
};
</script>
